const baseUrl = process.env.REACT_APP_BASE_URL;
const awsImageURL = process.env.REACT_APP_AWS_IMAGE_URL;
const chatUrl = process.env.REACT_APP_CHAT_URL;
const galleryUrl = process.env.REACT_APP_GALLERY_URL;
const bikeImageUrl = process.env.REACT_APP_BIKE_IMAGE_URL;
const imageUrl = process.env.REACT_APP_IMAGE_URL;

export { baseUrl, awsImageURL, chatUrl, galleryUrl, bikeImageUrl, imageUrl };
